/* eslint-disable eqeqeq */
/* eslint-disable indent */
import { getQuery, axios, webSocket, serverApi } from '@/common'

export default {
  namespaced: true,
  state: {
    gotIndexData: false,
    bannerList: [],
    videoList: [],

    clubVideoList: [],
    hasNextClubVideo: true,
    gettingNextClubVideo: false,
    newsList: [],
    hasNextNews: true,
    gettingNextNews: false,

    //======================资讯页面
    newsTab: {
      matchNews: {
        list: [],
        hasNext: true,
        gettingNext: false,
      },
      clubNews: {
        list: [],
        hasNext: true,
        gettingNext: false,
      },
      versionNews: {
        list: [],
        hasNext: true,
        gettingNext: false,
      },
      knowledge: {
        list: [],
        hasNext: true,
        gettingNext: false,
      },
    },
    newsBannerList: []


  },
  getters: {
    /* getChannelParamList: (state, getters) => (id) => {
      return state.channelList.find(item => item.id === id) || null;
    },
    getParamErrorList: (state, getters, rootState) => {
      let errorList = [];
      for (let channelCode of Object.keys(getters.getParamErrorMap)) {
        let channel = getters.getParamErrorMap[channelCode];
        if (channel.error) {
          errorList.push({
            name: channel.name,
            code: channelCode,
            id: channel.id,
            level: 1
          });
        }
        for (let subChannelCode of Object.keys(channel.subChannel)) {
          let subChannel = channel.subChannel[subChannelCode];
          if (subChannel.error) {
            errorList.push({
              name: subChannel.name,
              code: subChannelCode,
              id: subChannel.id,
              level: 2,
              mainChannel: {
                name: channel.name,
                code: channelCode,
                id: channel.id
              }
            });
          }
        }
      }
      return errorList;
    } */
  },
  mutations: {
    undateGotIndexData(state, got) {
      state.gotIndexData = got
    },
    undateHasNextClubVideo(state, has) {
      state.hasNextClubVideo = has
    },
    undateGettingNextClubVideo(state, flag) {
      state.gettingNextClubVideo = flag
    },
    undateHasNextNews(state, has) {
      state.hasNextNews = has
    },
    undateGettingNextNews(state, flag) {
      state.gettingNextNews = flag
    },
    undateIndexData(state, { bannerList, videoList, clubVideoList, newsList }) {
      state.bannerList = bannerList || state.bannerList;
      state.videoList = videoList || state.videoList;
      state.clubVideoList = clubVideoList || state.clubVideoList;
      state.newsList = newsList || state.newsList;
    },
    gettingNewsTabData(state, { tabKey }) {
      if (state.newsTab[tabKey]) {
        state.newsTab[tabKey].gettingNext = true
      }
    },
    undateNewsTabData(state, { tabKey, newsList, hasNext }) {
      if (state.newsTab[tabKey]) {
        state.newsTab[tabKey].list = newsList || state.newsTab[tabKey].list;
        state.newsTab[tabKey].gettingNext = false
        if (hasNext !== undefined) {
          state.newsTab[tabKey].hasNext = !!hasNext
        }
      }
    },
    undateNewsBanner(state, { list }) {
      state.newsBannerList = list || []
    },

  },
  actions: {
    async getIndexData({ commit, state, rootState, dispatch, getters }) {
      let result = await axios.get(`/api/eSportIndex`);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          let { bannerList, videoList, clubVideoList, newsList } = data;
          commit('undateIndexData', { bannerList, videoList, clubVideoList, newsList })
          commit('undateGotIndexData', true)
        }
      }
    },
    async getIndexDataWhileNeed({ commit, state, rootState, dispatch, getters }) {
      if (!state.gotIndexData) {
        dispatch('getIndexData')
      }
    },
    async getNextPageClubVideo({ commit, state, rootState, dispatch, getters }) {
      if (!state.hasNextClubVideo) {
        return
      }
      if (state.gettingNextClubVideo) {
        return
      }
      commit('undateGettingNextClubVideo', true);
      try {
        let result = await axios.get(`/api/eSport/getClubVideoByPage?page=${Math.ceil(state.clubVideoList.length / 10)}`);
        if (result.status == 200) {
          if (result.data) {
            let { list } = result.data;
            if (list && list.length == 0) {
              commit('undateHasNextClubVideo', false)
              return
            }
            commit('undateIndexData', { clubVideoList: [...state.clubVideoList, ...list] })
          }
        }
      } catch (e) { }
      commit('undateGettingNextClubVideo', false);
    },
    async getNextPageNews({ commit, state, rootState, dispatch, getters }) {
      if (!state.hasNextNews) {
        return
      }
      if (state.gettingNextNews) {
        return
      }
      commit('undateGettingNextNews', true);
      try {
        let result = await axios.get(`/api/eSport/getNewsListByPage?page=${Math.ceil(state.newsList.length / 10)}`);
        if (result.status == 200) {
          if (result.data) {
            let { list } = result.data;
            if (list && list.length == 0) {
              commit('undateHasNextNews', false)
              return
            }
            commit('undateIndexData', { newsList: [...state.newsList, ...list] })
          }
        }
      } catch (e) { }
      commit('undateGettingNextNews', false);
    },
    async getNewsPageIndexData({ commit, state, rootState, dispatch, getters }) {
      for (let tabKey of Object.keys(state.newsTab)) {
        commit('gettingNewsTabData', { tabKey })
      }
      let result = await axios.get(`/api/eSport/newsIndex`);
      if (result.status == 200) {
        if (result.data) {
          let data = result.data;
          commit('undateNewsBanner', { list: data.bannerList })

          for (let tabKey of Object.keys(state.newsTab)) {
            let tabItem = data.newsTab[tabKey];
            if (data.newsTab[tabKey]) {
              commit('undateNewsTabData', { tabKey, newsList: tabItem })
            } else {
              commit('undateNewsTabData', { tabKey, newsList: [] })
            }

          }
        }
      }
    },
    async getNewsPageIndexDataWhileNeed({ commit, state, rootState, dispatch, getters }) {
      let hasData = false;
      for (let tabKey of Object.keys(state.newsTab)) {
        if (state.newsTab[tabKey].list.length || state.newsTab[tabKey].gettingNext) {
          hasData = true;
          break
        }
      }
      if (!hasData) {
        dispatch('getNewsPageIndexData')
      }
    },
    async getNextPageTabNews({ commit, state, rootState, dispatch, getters }, { tabKey }) {
      if (!state.newsTab[tabKey]) {
        return
      }
      if (!state.newsTab[tabKey].hasNext || state.newsTab[tabKey].gettingNext) {
        return
      }
      commit('gettingNewsTabData', { tabKey })
      try {
        let result = await axios.get(`/api/eSport/newsTab/page`, {
          params: {
            page: Math.ceil(state.newsTab[tabKey].list.length / 10),
            tabKey
          }
        });
        if (result.status == 200) {
          if (result.data) {
            let { list } = result.data;
            commit('undateNewsTabData', { tabKey, newsList: [...state.newsTab[tabKey].list, ...list], hasNext: !!list.length })
            /* if (list && list.length == 0) {
              commit('undateHasNextNews', false)
              return
            }
            commit('undateIndexData', { newsList: [...state.newsList, ...list] }) */
          }
        }
      } catch (e) { }
    },
  }
};
